module.exports = __webpack_public_path__ + "static/media/anfall.7012bc30.mp3";